import {Input} from "../../UI/Input";
import {Helmet} from "react-helmet";
import {ERRORS} from "../../Consts/Errors";
import {useEffect, useState} from "react";
import {validationEmail, validationPassword} from "../../Global/Validation";
import {Button} from "../../UI/Button";
import Api from "../../API/api";
import {useDispatch} from "react-redux";
import {LoaderHide, LoaderShow} from "../../Store/Actions/Loader";
import {SHOW_TOAST} from "../../Store/Types/ToastTypes";
import {showToast} from "../../Store/Actions/ToastAction";
import {useLocation, useNavigate} from "react-router-dom";

export const SignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('userToken')
  const [inputs, setInputs] = useState({
  email: {
    id: "email",
    value: "",
    correct: false,
    error_text: ERRORS.email,
    error: false,
  },
    password: {
      id: "password",
      value: "",
      correct: false,
      error_text: ERRORS.password,
      error: false,
    },
  });

  useEffect(() => {
    if (location.pathname === '/') {
      navigate('/user')
    }
  }, [token])



  useEffect(() => {
    setInputs((old) => ({
      ...old,
      email: { ...old.email, correct: validationEmail(inputs.email.value) },
    }));
    setInputs((old) => ({
      ...old,
      password: {
        ...old.password,
        correct: validationPassword(inputs.password.value),
      },
    }));
  }, [inputs.email.value, inputs.password.value]);

  const localValidate = (id, validate) => {
    if (validate(inputs[id].value)) {
      setInputs((old) => ({
        ...old,
        [id]: {
          ...old[id],
          correct: true,
          error: false,
        },
      }));
      return true;
    } else {
      setInputs((old) => ({
        ...old,
        [id]: {
          ...old[id],
          success: false,
          error: true,
        },
      }));
      return false;
    }
  };

  const getValue = (target) => {
    setInputs((old) => ({
      ...old,
      [target.id]: {
        ...old[target.id],
        value: target.value.replace(/\s+/g, ""),
      },
    }));
  };

  const login = (e) => {
    const body = {
      email: inputs.email.value,
      password: inputs.password.value
    }
    e.preventDefault();
    const email = localValidate("email", validationEmail);
    const password = localValidate("password", validationPassword);
    if (email && password) {
      dispatch(LoaderShow())
      Api.postData('admin/login', body)
        .then(res => {
          dispatch(LoaderHide())
          localStorage.setItem('userToken', res.data.token)
          navigate('/users')
          dispatch(showToast({
            title: "Login",
            text: 'You have successfully logged in',
            type: "success",
          }))
        })
        .catch(err => {
          dispatch(LoaderHide())
          console.log(err.response.data.message)
          dispatch(showToast({
            title: "Login",
            text: err.response.data.message,
            type: "error",
          }))
        })
    }
  };

  return (
    <div className='signinPage'>
      <Helmet>
        <meta charSet="utf-8" />
        <title>SARK ADMIN | LOGIN</title>
      </Helmet>
      <div className="signin">
        <p className="signin__title">sark</p>
        <p className="signin__subtitle">ADMIN</p>
        <form action="#" onSubmit={login}>
          <div className="signin__field">
            <label>Email</label>
            <div className="signin__input">
              <Input
                placeholder={"example@gmail.com"}
                type="text"
                id={inputs.email.id}
                value={inputs.email.value}
                error_text={inputs.email.error_text}
                error={inputs.email.error}
                correct={inputs.email.correct}
                max_length="50"
                getValue={getValue}
              />
            </div>
          </div>
          <div className="signin__field">
            <label>Password</label>
            <div className="signin__input">
              <Input
                placeholder={"Your password"}
                type="password"
                id={inputs.password.id}
                value={inputs.password.value}
                error_text={inputs.password.error_text}
                correct={inputs.password.correct}
                error={inputs.password.error}
                max_length="50"
                getValue={getValue}
              />
            </div>
          </div>
          <div className="signin__button">
            <Button text="Log in" type="submit" />
          </div>
        </form>
      </div>
    </div>
  )
}
